<script lang="ts" setup>
import NuxtLinkFlat from '~theme/components/atoms/NuxtLinkFlat.vue';
import SectionContainer from '~theme/components/molecules/SectionContainer.vue';

defineProps<{
  message: string;
  status: number;
  additionalMessage: string;
}>();
</script>

<template>
  <SectionContainer>
    <main :class="$style.page">
      <!--
      titleをh2にすると、SSRが200で、CSRでエラーが発生した時に、
      SERPのタイトルに反映されてしまう可能性があるため、あえてpタグにする
      ref: https://400f-jp.slack.com/archives/C014WA21T4J/p1748914790620279?thread_ts=1748913291.644549&cid=C014WA21T4J
      -->
      <p v-if="message" :class="$style.page__title">{{ message }}</p>
      <p v-if="status" :class="$style.page__code">{{ status }}</p>
      <p v-if="additionalMessage" :class="$style.page__additional">
        {{ additionalMessage }}
      </p>
      <img :class="$style.page__image" src="./img-error.png" alt="" />
      <NuxtLinkFlat :class="$style.page__link" :to="{ path: '/' }"
        >トップページへ</NuxtLinkFlat
      >
    </main>
  </SectionContainer>
</template>

<style lang="scss" module>
.page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 36px 0;

  @include desktop-only {
    padding: 72px 0;
  }

  &__title {
    text-align: center;
    font-size: 32px;
    font-weight: bold;
    color: $color-text-and-object-medium-emphasis;

    @include small-mobile-only {
      font-size: 28px;
    }

    @include tablet-upper {
      font-size: 40px;
    }
  }

  &__code {
    font-size: 100px;
    font-weight: bold;
    color: $color-text-and-object-medium-emphasis;
    line-height: 1;

    @include small-mobile-only {
      font-size: 64px;
    }

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }

  &__additional {
    text-align: center;
    font-size: 18px;
    color: $color-text-and-object-medium-emphasis;

    &:nth-child(n + 2) {
      margin-top: 12px;
    }
  }

  &__image {
    width: 80%;
    max-width: 400px;

    &:nth-child(n + 2) {
      margin-top: 36px;
    }
  }

  &__link {
    &:nth-child(n + 2) {
      margin-top: 24px;
    }
  }
}
</style>
